module.exports = __webpack_public_path__ + "static/media/register_background.20780cef.png";